<template>
  <div>
    <div class="selectors">
      <label>
        Campagne:
        <select class="form-control" v-model="year" :disabled="!$store.state.self.isAdmin">
          <option v-for="y of yearList" :key="y" :value="y">{{ y }}</option>
        </select>
      </label>
      <Substitute v-if="$store.state.self.isAdmin" class="substitute" innerClass="bg-cmem" :frsList="frsList"
        :selectedFrsGuid="selectedFrsGuid" @update="selectedFrsGuid = $event"></Substitute>
      <div v-else></div>
    </div>

    <form @submit="update">
      <!--Row 1-->
      <label>
        CA Global Société {{ year - 1 }}
        <InputFormattedNumber class="form-control" :currency="true" v-model="appointmentFormData.companyCa" />
      </label>
      <label>
        CA avec CMEM {{ year - 1 }}
        <InputFormattedNumber class="form-control" :currency="true" v-model="appointmentFormData.ca" />
      </label>
      <div></div>

      <!--Row 2-->
      <label>
        Situation du marché (%)
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.marketSituation" />
      </label>
      <label>
        Evolution de votre CA global (%)
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.yourCompany" />
      </label>
      <label>
        Evolution de votre CA avec CMEM (%)
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.withCmem" />
      </label>


      <!--Row 3-->
      <label>
        Engagement sur Taux Fixe {{ year }} (%)
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.fixedRateCommitment" />
      </label>
      <label>
        Atterissage CA {{ year - 1 }} avec CMEM
        <InputFormattedNumber class="form-control" :currency="true" v-model="appointmentFormData.finalCaWithCmem" />
      </label>
      <label>
        Atterissage Volume {{ year - 1 }} avec CMEM
        <InputFormattedNumber class="form-control" v-model="appointmentFormData.finalVolumeWithCmem" />
      </label>

      <!--Row 4-->
      <label>
        Objectif CA {{ year }}
        <InputFormattedNumber class="form-control" :currency="true" v-model="appointmentFormData.targetCa" />
      </label>
      <label>
        Objectif Volume {{ year }}
        <InputFormattedNumber class="form-control" v-model="appointmentFormData.targetVolume" />
      </label>
      <div></div>

      <!--Row 5-->
      <label>
        Hausse tarif {{ year - 1 }} (%)
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.priceIncrease" />
      </label>
      <label>
        Hausse Tarif Marché {{ year - 1 }} (%)
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.marketPriceIncrease" />
      </label>
      <label>
        Estimation Hausse Tarif {{ year }} (%)
        <input class="form-control" type="number" step="0.01"
          v-model="appointmentFormData.estimatedMarketPriceIncrease" />
      </label>


      <!--Row 7-->
      <label>
        Commentaire pour le rendez-vous CMEM
        <textarea class="form-control" placeholder="Texte libre" v-model="appointmentFormData.comment1" />
      </label>
      <label>
        Informations Fournisseurs (Société / Innovation / Logistique)
        <textarea class="form-control" v-model="appointmentFormData.supplierInformation" />
      </label>
      <div></div>


      <!--Row 13-->
      <strong>Impact transport des produits :</strong>
      <div></div>
      <div></div>

      <!--Row 14-->
      <label>
        % Fabrication Française
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.madeInFrance" />
      </label>
      <label>
        % Fabrication Zone CE (Hors France)
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.madeInEuropeOutsideFrance" />
      </label>
      <label>
        % Fabrication Hors Europe
        <input class="form-control" type="number" step="0.01" v-model="appointmentFormData.madeOutOfEurope" />
      </label>

      <!--Row 15-->
      <strong>Démarche RSE :</strong>
      <div></div>
      <div></div>

      <!--Row 16-->
      <div>
        <div>Norme et certificats :</div>
        <div class="d-flex align-items-center">
          <label class="d-flex me-4 align-items-center">
            <input class="me-2" type="radio" :value="true" v-model="appointmentFormData.hasStandards" />
            Oui
          </label>
          <label class="d-flex me-4">
            <input class="me-2" type="radio" :value="false" v-model="appointmentFormData.hasStandards" />
            Non
          </label>
          <input class="form-control" type="text" v-model="appointmentFormData.standardsName" />
        </div>
      </div>
      <div>
        <div>Rapport RSE / QSE :</div>
        <div class="d-flex align-items-center">
          <label class="d-flex me-4 align-items-center">
            <input class="me-2" type="radio" :value="true" v-model="appointmentFormData.hasRseReport" />
            Oui
          </label>
          <label class="d-flex me-4">
            <input class="me-2" type="radio" :value="false" v-model="appointmentFormData.hasRseReport" />
            Non
          </label>
        </div>
      </div>
      <div>
        <div>Solution gestion déchets :</div>
        <div class="d-flex align-items-center">
          <label class="d-flex me-4 align-items-center">
            <input class="me-2" type="radio" :value="true" v-model="appointmentFormData.hasWasteManagementSolution" />
            Oui
          </label>
          <label class="d-flex me-4">
            <input class="me-2" type="radio" :value="false" v-model="appointmentFormData.hasWasteManagementSolution" />
            Non
          </label>
          <input class="form-control" type="text" v-model="appointmentFormData.wasteManagementSolutionName" />
        </div>
      </div>

      <!--Row 19-->
      <strong>Mesure des actions RSE :</strong>
      <div></div>
      <div></div>

      <!--Row 20-->
      <div>
        <div>Note ecovadis ou autre :</div>
        <div class="d-flex align-items-center">
          <label class="d-flex me-4 align-items-center">
            <input class="me-2" type="radio" :value="true" v-model="appointmentFormData.hasEcovadisNote" />
            Oui
          </label>
          <label class="d-flex me-4">
            <input class="me-2" type="radio" :value="false" v-model="appointmentFormData.hasEcovadisNote" />
            Non
          </label>
          <input class="form-control" type="text" v-model="appointmentFormData.ecovadisNoteValue" />
        </div>
      </div>
      <div>
        <div>Bilan carbone :</div>
        <div class="d-flex align-items-center">
          <label class="d-flex me-4 align-items-center">
            <input class="me-2" type="radio" :value="true" v-model="appointmentFormData.hasCarbonFootPrint" />
            Oui
          </label>
          <label class="d-flex me-4">
            <input class="me-2" type="radio" :value="false" v-model="appointmentFormData.hasCarbonFootPrint" />
            Non
          </label>
          <input class="form-control" type="text" v-model="appointmentFormData.carbonFootPrintValue" />
        </div>
      </div>
      <div>
        <div>Indice fournisseur :</div>
        <div class="d-flex align-items-center">
          <label class="d-flex me-4 align-items-center">
            <input class="me-2" type="radio" :value="true" v-model="appointmentFormData.hasSupplierIndex" />
            Oui
          </label>
          <label class="d-flex me-4">
            <input class="me-2" type="radio" :value="false" v-model="appointmentFormData.hasSupplierIndex" />
            Non
          </label>
          <input class="form-control" type="text" v-model="appointmentFormData.supplierIndexValue" />
        </div>
      </div>

      <!-- Row 14 -->
      <input class="mt-5" type="submit" value="Sauvegarder" />
    </form>
  </div>
</template>

<script>
import {
  getFrsList,
  getFrsAppointmentFormData,
} from "@/utils/frs";

import { updateAppointmentFormData } from "@/utils/drone";

import { getCampaignsYear } from "@/utils/period";

import Substitute from "@/components/Substitute";
import InputFormattedNumber from "@/components/InputFormattedNumber";

const defaultAppointmentFormData = {
  "guid": "",
  "contractGuid": "",
  "companyCa": 0,
  "ca": 0,
  "marketSituation": 0,
  "cmemMarketODW": 0,
  "yourCompany": 0,
  "withCmem": 0,
  "finalCaWithCmem": 0,
  "finalVolumeWithCmem": 0,
  "targetCa": 0,
  "targetVolume": 0,
  "priceIncrease": 0,
  "marketPriceIncrease": 0,
  "estimatedMarketPriceIncrease": 0,
  "estimatedFixedRfaN": 0,
  "estimatedIndividualRfaN": 0,
  "estimatedTotalRfaN": 0,
  "estimatedFixedRfaRateN": 0,
  "estimatedIndividualRfaRateN": 0,
  "estimatedTotalRfaRateN": 0,
  "fixedRateCommitment": 0,
  "specificContractLineAndLight": false,
  "specificContractWoodalliance": false,
  "explosivesPrecursors": false,
  "comment1": "",
  "comment2": "",
  "comment3": "",
  "madeInFrance": 0,
  "madeInEuropeOutsideFrance": 0,
  "madeOutOfEurope": 0,
  "supplierInformation": "",
  "hasStandards": false,
  "standardsName": "",
  "hasRseReport": false,
  "hasWasteManagementSolution": false,
  "wasteManagementSolutionName": "",
  "hasInnovationInfo": false,
  "innovationInfoValue": "",
  "fdesIntegrated": false,
  "hasGreenProductLabel": false,
  "greenProductLabelName": "",
  "hasEcovadisNote": false,
  "ecovadisNoteValue": "",
  "hasCarbonFootPrint": false,
  "carbonFootPrintValue": "",
  "hasSupplierIndex": false,
  "supplierIndexValue": "",
}

export default {
  name: "AppointmentForm",
  components: { Substitute, InputFormattedNumber },
  data() {
    return {
      appointmentFormData: Object.assign({}, defaultAppointmentFormData),
      selectedFrsGuid: "",
      frsList: [],
      yearList: [],
      year: -1
    }
  },
  mounted() {
    if (!this.$store.state.self.isAdmin && !this.$store.state.self.isSupplier)
      this.$router.replace("/");
    getCampaignsYear().then(years => {
      if (!years) return;
      this.yearList = years;
      this.year = Math.max(...years);
    });
  },
  watch: {
    selectedFrsGuid() {
      this.initData();
    },
    year() {
      // Si la campagne change, on enlève le frs sélectionné, et on récupère les frs actifs sur la campagne
      if (this.$store.state.self.isAdmin) {
        getFrsList(this.year).then(res => {
          this.frsList = res
          this.selectedFrsGuid = "";
          this.appointmentFormData = Object.assign({}, defaultAppointmentFormData);
        });
      } else if (this.$store.state.self.isSupplier) { // Si on est pas admin, le frs sélectionné est nous-même
        this.selectedFrsGuid = this.$store.state.self.guid;
      }
    }
  },
  methods: {
    initData() {
      if (this.selectedFrsGuid) {
        getFrsAppointmentFormData(this.selectedFrsGuid, this.year, true).then(data => {
          this.syncAppointementFormFields(data);
        });
      }
    },
    update(e) {
      e.preventDefault();

      if (this.appointmentFormData.contractGuid && this.year != -1 && this.selectedFrsGuid) {
        updateAppointmentFormData(this.selectedFrsGuid, this.appointmentFormData, this.year).then(() => {
          this.initData();
        });
      }
    },
    syncAppointementFormFields(appointmentFormResponse) {
      // On initialise les models via l'objet reçu
      this.appointmentFormData.guid = appointmentFormResponse.Guid;
      this.appointmentFormData.contractGuid = appointmentFormResponse.ContractGuid;
      this.appointmentFormData.companyCa = appointmentFormResponse.CompanyCa;
      this.appointmentFormData.marketSituation = appointmentFormResponse.MarketSituation;
      this.appointmentFormData.cmemMarketODW = appointmentFormResponse.CMEMMarketODW;
      this.appointmentFormData.yourCompany = appointmentFormResponse.YourCompany;
      this.appointmentFormData.withCmem = appointmentFormResponse.WithCmem;
      this.appointmentFormData.finalCaWithCmem = appointmentFormResponse.FinalCaWithCmem;
      this.appointmentFormData.finalVolumeWithCmem = appointmentFormResponse.FinalVolumeWithCmem;
      this.appointmentFormData.targetCa = appointmentFormResponse.TargetCa;
      this.appointmentFormData.targetVolume = appointmentFormResponse.TargetVolume;
      this.appointmentFormData.priceIncrease = appointmentFormResponse.PriceIncrease;
      this.appointmentFormData.marketPriceIncrease = appointmentFormResponse.MarketPriceIncrease;
      this.appointmentFormData.estimatedMarketPriceIncrease = appointmentFormResponse.EstimatedMarketPriceIncrease;
      this.appointmentFormData.estimatedFixedRfaN = appointmentFormResponse.EstimatedFixedRfaN;
      this.appointmentFormData.estimatedIndividualRfaN = appointmentFormResponse.EstimatedIndividualRfaN;
      this.appointmentFormData.estimatedTotalRfaN = appointmentFormResponse.EstimatedTotalRfaN;
      this.appointmentFormData.estimatedFixedRfaRateN = appointmentFormResponse.EstimatedFixedRfaRateN;
      this.appointmentFormData.estimatedIndividualRfaRateN = appointmentFormResponse.EstimatedIndividualRfaRateN;
      this.appointmentFormData.estimatedTotalRfaRateN = appointmentFormResponse.EstimatedTotalRfaRateN;
      this.appointmentFormData.fixedRateCommitment = appointmentFormResponse.FixedRateCommitment;
      this.appointmentFormData.specificContractLineAndLight = appointmentFormResponse.SpecificContractLineAndLight;
      this.appointmentFormData.specificContractWoodalliance = appointmentFormResponse.SpecificContractWoodalliance;
      this.appointmentFormData.explosivesPrecursors = appointmentFormResponse.ExplosivesPrecursors;
      this.appointmentFormData.comment1 = appointmentFormResponse.Comment1;
      this.appointmentFormData.comment2 = appointmentFormResponse.Comment2;
      this.appointmentFormData.comment3 = appointmentFormResponse.Comment3;
      this.appointmentFormData.madeInFrance = appointmentFormResponse.MadeInFrance;
      this.appointmentFormData.madeInEuropeOutsideFrance = appointmentFormResponse.MadeInEuropeOutsideFrance;
      this.appointmentFormData.madeOutOfEurope = appointmentFormResponse.MadeOutOfEurope;
      this.appointmentFormData.supplierInformation = appointmentFormResponse.SupplierInformation;
      this.appointmentFormData.ca = appointmentFormResponse.Ca;
      this.appointmentFormData.hasStandards = appointmentFormResponse.HasStandards;
      this.appointmentFormData.standardsName = appointmentFormResponse.StandardsName;
      this.appointmentFormData.hasRseReport = appointmentFormResponse.HasRseReport;
      this.appointmentFormData.hasWasteManagementSolution = appointmentFormResponse.HasWasteManagementSolution;
      this.appointmentFormData.wasteManagementSolutionName = appointmentFormResponse.WasteManagementSolutionName;
      this.appointmentFormData.hasInnovationInfo = appointmentFormResponse.HasInnovationInfo;
      this.appointmentFormData.innovationInfoValue = appointmentFormResponse.InnovationInfoValue;
      this.appointmentFormData.fdesIntegrated = appointmentFormResponse.FdesIntegrated;
      this.appointmentFormData.hasGreenProductLabel = appointmentFormResponse.HasGreenProductLabel;
      this.appointmentFormData.greenProductLabelName = appointmentFormResponse.GreenProductLabelName;
      this.appointmentFormData.hasEcovadisNote = appointmentFormResponse.HasEcovadisNote;
      this.appointmentFormData.ecovadisNoteValue = appointmentFormResponse.EcovadisNoteValue;
      this.appointmentFormData.hasCarbonFootPrint = appointmentFormResponse.HasCarbonFootPrint;
      this.appointmentFormData.carbonFootPrintValue = appointmentFormResponse.CarbonFootPrintValue;
      this.appointmentFormData.hasSupplierIndex = appointmentFormResponse.HasSupplierIndex;
      this.appointmentFormData.supplierIndexValue = appointmentFormResponse.SupplierIndexValue;
    }
  }
}
</script>

<style scoped>
form {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  column-gap: 18px;
  row-gap: 10px;
  max-width: 1650px;
  margin: auto;
}

label {
  height: min-content;
  /*align-self: flex-end;*/
}

input,
textarea {
  display: block;
  max-width: 600px;
  resize: vertical;
}

textarea {
  min-height: 120px;
}

input[type="checkbox"] {
  display: inline;
}

input[type="submit"] {
  grid-column: span 3;
  justify-self: center;
  background-color: #A7C13C;
  color: white;
  padding: 8px 24px;
  border-radius: 6px;
  border: none;
  font-size: 1.2em;
}

.substitute {
  display: inline-block;
  min-width: min-content;
  width: 250px;
  color: white;
}

.selectors {
  max-width: 1650px;
  margin: auto;
  margin-bottom: 2em;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.selectors select {
  width: 200px;
}
</style>

<style>
.bg-cmem {
  background-color: #A7C13C !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Fournisseur/AppointmentForm.vue